export default "__VITE_ASSET__BUAuCXFf__"